var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Anime-fields" }, [
    _c("div", { staticClass: "Anime-img" }, [
      _c("img", { attrs: { src: _vm.anime.image.value, alt: "anime-label" } }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "Anime-information" }, [
      _c("h1", [_vm._v(_vm._s(_vm.anime.title.english.value))]),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.anime.title.japanese.value))]),
      _vm._v(" "),
      _c("ul", { staticClass: "stats" }, [
        _c("li", [
          _c("strong", [_vm._v("Episodes:")]),
          _vm._v(" " + _vm._s(_vm.anime.episodes.value)),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Duration:")]),
          _vm._v(" " + _vm._s(_vm.anime.duration.value)),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Premiered:")]),
          _vm._v(" " + _vm._s(_vm.anime.premiered.value)),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Status:")]),
          _vm._v(" " + _vm._s(_vm.anime.status.value)),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Score:")]),
          _vm._v(" " + _vm._s(_vm.anime.score.value)),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Genres:")]),
          _vm._v(" " + _vm._s(_vm.anime.genres.toString())),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Rating:")]),
          _vm._v(" " + _vm._s(_vm.anime.rating.value)),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "synopsis-section" }, [
        _c("h4", [_vm._v("Synopsis:")]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.anime.synopsis.value))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }